/**
 * @deprecated Use `import { sazkaAlert } from "@sazka/design-system/src/modal-alert/mount-alert"` as a DS component;
 */
export const sazkaAlert = (
    title: string,
    text: string = null,
    linkText: string = null,
    link: string = null,
    buttonText = "OK",
    customHtml = "",
    hasExtraButton = true,
    errorCode?: number
): Promise<boolean> => {
    return new Promise((resolve) => {
        const heading = $(
            `<h2 class="sazka-alert__title" style="visibility:hidden; display:inline-block;">${title}</h2>`
        );
        $("body").append(heading);
        const maxWidth = Math.max(heading.width(), 300);
        heading.remove();

        const template = `
        <div class="modal fade sazka-alert" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal-content--without-close">
                    ${errorCode ? `<span class='sazka-alert__ecode'>ecode: ${errorCode}</span>` : ""}
                    <h2 class="sazka-alert__title">${title}</h2>
                    ${text ? `<p class="sazka-alert__text" style="max-width: ${maxWidth}px;">${text}</p>` : ""}
                    <div class="sazka-alert__button-group">
                        ${linkText ? `<a class="btn btn-primary sazka-alert--btn" href="${link}">${linkText}</a>` : ""}
                        ${
                            hasExtraButton
                                ? `<button type="button" class="btn ${
                                      linkText ? "btn-outline-primary" : "btn-primary"
                                  }" data-dismiss="modal">${buttonText}</button>`
                                : ""
                        }
                    </div>
                    ${customHtml}
                </div>
            </div>
        </div>`;

        const $modal = $(template);
        $("body").append($modal);
        $modal.modal("show");
        $modal.find(".sazka-alert--btn").on("click", () => {
            resolve(false);
            $modal.modal("hide");
        });
        $modal.on("hidden.bs.modal", () => {
            $modal.modal("dispose").remove();
            if ($(".modal:visible").length) {
                $("body").addClass("modal-open");
            }
            resolve(true);
        });
    });
};
